import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

export const useMembership = () => {
  const [currentPlan, setCurrentPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMembership = useCallback(async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      const response = await api.get('/subscriptions/current', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCurrentPlan(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const syncWithStripe = useCallback(async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      await api.post(
        '/subscriptions/sync',
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // Refetch membership details after sync
      await fetchMembership();
    } catch (err) {
      console.error('Error syncing with Stripe:', err);
      setError(err.message);
    }
  }, [fetchMembership]);

  useEffect(() => {
    fetchMembership();
  }, [fetchMembership]);

  // Return the sync function along with other state
  return {
    currentPlan,
    loading,
    error,
    refetch: fetchMembership,
    syncWithStripe,
  };
};
// // src/hooks/useMembership.js
// import { useState, useEffect } from 'react';
// // import api from '../utils/api';
// import axios from 'axios';
// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   timeout: 5000,
// });
// export const useMembership = () => {
//   const [currentPlan, setCurrentPlan] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchMembership = async () => {
//       try {
//         const token = localStorage.getItem('ownerToken');

//         const response = await api.get('/subscriptions/current', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setCurrentPlan(response.data);
//         setError(null);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMembership();
//   }, []);

//   return { currentPlan, loading, error };
// };
